<template>
  <div class="toc">
    <div>
      <hr style="height: 0.08rem; border: none; background-color: var(--outline-light-colour)" />
      <div style="display: flex; flex-direction: row">
        <input
          v-if="!isPlacementMode"
          type="checkbox"
          class="datasets__table-checkbox"
          name="analysis-checkbox"
          id="table-of-contents-slide-selection"
          v-model="selectedSlide"
          @click="addToSelectedSlide"
        />
        <div>
          {{ document.name }}
        </div>
        <!--------------------------------------------
        |
        | Slide options
        |
        --------------------------------------------->
        <div
          style="
            z-index: 10;
            background-color: white;
            border-top: 0;
            border-radius: 0 0 4px 4px;
            color: var(--base-colour);
            position: absolute;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
            border: 1px solid var(--outline-colour);
            border-radius: 8px;
            margin-left: 2rem;
            width: 13rem;
            margin-top: -0.5rem;
          "
          v-if="
            showNodesCheckOptions.length &&
            showNodesCheckOptions[showNodesCheckOptions.length - 1].id == document.id
          "
        >
          <div style="margin-left: 0.5rem" v-if="!isPlacementMode">
            <VisibleText> {{ checkedNodes.length }} selected</VisibleText>
          </div>
          <div class="theme-options-btn" @click="onClickDelete" v-if="!isPlacementMode">
            <!-- <SvgIconDecorative icon="search" /> -->
            <VisibleText>Delete from report</VisibleText>
          </div>
          <div
            class="theme-options-btn"
            :class="placeWhere == 'below' ? 'theme-options-btn-selected' : ''"
            @click="onClickPlace('below')"
            v-if="isPlacementMode"
          >
            <VisibleText>Place below</VisibleText>
          </div>
        </div>
      </div>

      <div
        v-for="(node, node_index) in this.document.nodes"
        :key="node_index"
        style="margin-left: 1rem; display: flex; flex-direction: column"
      >
        <div v-if="node.type === 'section'" class="toc__section">
          <input
            type="checkbox"
            class="datasets__table-checkbox"
            name="analysis-checkbox"
            :id="'table-of-contents-section-selection-' + node_index"
            @click="addToSelectedSections(node)"
            v-model="selectedSections[node_index]"
          />
          <div v-if="node.meta.subTitle" class="toc__section-text">
            Section {{ node.meta.subTitle }}
          </div>
          <div v-else>Section</div>
          <!--------------------------------------------
              |
              | Section options
              |
              --------------------------------------------->
          <div
            style="
              z-index: 10;
              background-color: white;
              border-top: 0;
              border-radius: 0 0 4px 4px;
              color: var(--base-colour);
              position: absolute;
              box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
              border: 1px solid var(--outline-colour);
              border-radius: 8px;
              margin-left: 2rem;
              width: 13rem;
            "
            v-if="
              showNodesCheckOptions.length &&
              showNodesCheckOptions[showNodesCheckOptions.length - 1].uuid == node.uuid
            "
          >
            <div style="margin-left: 0.5rem" v-if="!isPlacementMode">
              <VisibleText> {{ checkedNodes.length }} selected</VisibleText>
            </div>
            <div class="theme-options-btn" @click="onClickDelete" v-if="!isPlacementMode">
              <!-- <SvgIconDecorative icon="search" /> -->
              <VisibleText>Delete from report</VisibleText>
            </div>
            <div
              class="theme-options-btn"
              :class="placeWhere == 'above' ? 'theme-options-btn-selected' : ''"
              @click="onClickPlace('above')"
              v-if="isPlacementMode"
            >
              <VisibleText>Place above</VisibleText>
            </div>
            <div
              class="theme-options-btn"
              :class="placeWhere == 'below' ? 'theme-options-btn-selected' : ''"
              @click="onClickPlace('below')"
              v-if="isPlacementMode"
            >
              <VisibleText>Place below</VisibleText>
            </div>
          </div>
        </div>
        <div v-if="node.type === 'section'">
          <div
            v-for="(subnode, subindex) in this.document.nodes[node_index].content"
            :key="subindex"
            style="margin-left: 1rem; display: flex; flex-direction: column"
          >
            <div class="toc__section">
              <input
                type="checkbox"
                class="datasets__table-checkbox"
                name="analysis-checkbox"
                :id="'table-of-contents-section-selection-' + node_index + '-' + subindex"
                @click="addToSelectedSections(subnode, node)"
                v-model="selectedSubSections[node_index * 10 + subindex]"
              />
              <!--------------------------------------------
                |
                | Section node options
                |
                --------------------------------------------->
              <div
                style="
                  z-index: 10;
                  background-color: white;
                  border-top: 0;
                  border-radius: 0 0 4px 4px;
                  color: var(--base-colour);
                  position: absolute;
                  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                  border: 1px solid var(--outline-colour);
                  border-radius: 8px;
                  margin-left: 2rem;
                  width: 13rem;
                "
                v-if="
                  showNodesCheckOptions.length &&
                  showNodesCheckOptions[showNodesCheckOptions.length - 1].uuid == subnode.uuid
                "
              >
                <div style="margin-left: 0.5rem" v-if="!isPlacementMode">
                  <VisibleText> {{ checkedNodes.length }} selected</VisibleText>
                </div>
                <div class="theme-options-btn" @click="onClickDelete" v-if="!isPlacementMode">
                  <!-- <SvgIconDecorative icon="search" /> -->
                  <VisibleText>Delete from report</VisibleText>
                </div>

                <div
                  class="theme-options-btn"
                  :class="placeWhere == 'above' ? 'theme-options-btn-selected' : ''"
                  @click="onClickPlace('above')"
                  v-if="isPlacementMode"
                >
                  <VisibleText>Place above</VisibleText>
                </div>
                <div
                  class="theme-options-btn"
                  :class="placeWhere == 'below' ? 'theme-options-btn-selected' : ''"
                  @click="onClickPlace('below')"
                  v-if="isPlacementMode"
                >
                  <VisibleText>Place below</VisibleText>
                </div>
              </div>
              <span v-if="subnode.type === 'heading'" class="toc__section-text">
                Heading {{ parseHeader(subnode.content) }}
              </span>
              <div v-else-if="subnode.type === 'banner'" class="toc__section-text">
                <VisibleText> Banner </VisibleText>
              </div>
              <div v-else-if="subnode.type === 'titlePage'" class="toc__section-text">
                <div v-if="subnode.content.heading.length">
                  Heading {{ parseHeader(subnode.content.heading) }}
                </div>
                <div v-else>Heading</div>
              </div>
              <div v-else-if="subnode.type === 'text'" class="toc__section-text">
                <div v-if="subnode.content">
                  <div v-if="subnode.content.length < 51">Text {{ subnode.content }}</div>
                  <div v-else>Text {{ subnode.content.substring(0, 50) + '...' }}</div>
                </div>
                <div v-else>Text</div>
              </div>
              <div v-else-if="subnode.type === 'priorityMatrix'" class="toc__section-text">
                <VisibleText>Priority Matrix</VisibleText>
              </div>
              <div v-else-if="subnode.type === 'horizontalBarChart'" class="toc__section-text">
                <VisibleText>Bar chart (horizontal)</VisibleText>
              </div>
              <div v-else-if="subnode.type === 'horizontalLineChart'" class="toc__section-text">
                <VisibleText>Line chart (horizontal)</VisibleText>
              </div>
              <div v-else-if="subnode.type === 'verticalBarChart'" class="toc__section-text">
                <VisibleText>Bar chart (vertical)</VisibleText>
              </div>
              <div
                v-else-if="subnode.type === 'table' || subnode.type === 'textThemeTable'"
                class="toc__section-text"
              >
                <VisibleText>Table</VisibleText>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="toc__section">
          <input
            type="checkbox"
            class="datasets__table-checkbox"
            name="analysis-checkbox"
            :id="'table-of-contents-selection-' + node_index"
            @click="addToSelectedSections(node)"
            v-model="selectedSections[node_index]"
          />
          <!--------------------------------------------
            |
            | Node options
            |
            --------------------------------------------->
          <div
            style="
              z-index: 10;
              background-color: white;
              border-top: 0;
              border-radius: 0 0 4px 4px;
              color: var(--base-colour);
              position: absolute;
              box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
              border: 1px solid var(--outline-colour);
              border-radius: 8px;
              margin-left: 2rem;
              width: 13rem;
            "
            v-if="
              showNodesCheckOptions.length &&
              showNodesCheckOptions[showNodesCheckOptions.length - 1].uuid == node.uuid
            "
          >
            <div style="margin-left: 0.5rem" v-if="!isPlacementMode">
              <VisibleText> {{ checkedNodes.length }} selected</VisibleText>
            </div>
            <div class="theme-options-btn" @click="onClickDelete" v-if="!isPlacementMode">
              <!-- <SvgIconDecorative icon="search" /> -->
              <VisibleText>Delete</VisibleText>
            </div>

            <div
              class="theme-options-btn"
              :class="placeWhere == 'above' ? 'theme-options-btn-selected' : ''"
              @click="onClickPlace('above')"
              v-if="isPlacementMode"
            >
              <VisibleText>Place above</VisibleText>
            </div>
            <div
              class="theme-options-btn"
              :class="placeWhere == 'below' ? 'theme-options-btn-selected' : ''"
              @click="onClickPlace('below')"
              v-if="isPlacementMode"
            >
              <VisibleText>Place below</VisibleText>
            </div>
          </div>
          <span v-if="node.type === 'heading'" class="toc__section-text">
            Heading {{ parseHeader(node.content) }}
          </span>
          <div v-else-if="node.type === 'banner'" class="toc__section-text">
            <VisibleText> Banner </VisibleText>
          </div>
          <div v-else-if="node.type === 'titlePage'" class="toc__section-text">
            <div v-if="node.content.heading.length">
              Heading {{ parseHeader(node.content.heading) }}
            </div>
            <div v-else>Heading</div>
          </div>
          <div v-else-if="node.type === 'text'" class="toc__section-text">
            <div v-if="node.content">
              <div v-if="node.content.length < 51">Text {{ node.content }}</div>
              <div v-else>Text {{ node.content.substring(0, 50) + '...' }}</div>
            </div>
            <div v-else>Text</div>
          </div>
          <div v-else-if="node.type === 'priorityMatrix'" class="toc__section-text">
            <VisibleText>Priority Matrix</VisibleText>
          </div>
          <div v-else-if="node.type === 'horizontalBarChart'" class="toc__section-text">
            <VisibleText>Bar chart (horizontal)</VisibleText>
          </div>
          <div v-else-if="node.type === 'horizontalLineChart'" class="toc__section-text">
            <VisibleText>Line chart (horizontal)</VisibleText>
          </div>
          <div v-else-if="node.type === 'verticalBarChart'" class="toc__section-text">
            <VisibleText>Bar chart (vertical)</VisibleText>
          </div>
          <div
            v-else-if="node.type === 'table' || node.type === 'textThemeTable'"
            class="toc__section-text"
          >
            <VisibleText>Table</VisibleText>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PigeonDocModel from '../../models/PigeonDocModel';
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

// import DeleteIcon from "../../assets/delete.svg"
// import DocumentBreakIcon from "../../assets/TableOfContents/document-page-break-svgrepo-com.svg"
// import TextIcon from "../../assets/TableOfContents/text-svgrepo-com.svg"
// import HeaderIcon from "../../assets/TableOfContents/header-svgrepo-com.svg"
// import ScatterMatrixIcon from "../../assets/TableOfContents/scatter-matrix-svgrepo-com.svg"
// import ChartIcon from "../../assets/TableOfContents/chart-svgrepo-com.svg"
// import TableIcon from "../../assets/TableOfContents/table-svgrepo-com.svg"
// import DownChevronIcon from '../../assets/TableOfContents/down-chevron.svg';

import ConfirmMixin from '@/utils/mixins/confirmMixin.js';

export default {
  name: 'TableOfContents',
  // components: {
  //   DeleteIcon,
  //   DocumentBreakIcon,
  //   TextIcon,
  //   HeaderIcon,
  //   ScatterMatrixIcon,
  //   ChartIcon,
  //   TableIcon,
  //   DownChevronIcon
  // },
  mixins: [ConfirmMixin],
  props: {
    document: {
      default: () => {},
      type: PigeonDocModel,
    },
    index: {
      default: () => -1,
      type: Number,
    },
    isPlacementMode: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      showAddNode: false,
      nodesByIndex: [],
      allNodes: [],
      hidePlaceHandler: false,
      selectedSlide: false,
      selectedSections: [],
      selectedSubSections: [],
      checkedNodes: [],
      showNodesCheckOptions: [],
      placeWhere: 'below',
    };
  },
  methods: {
    async parseNodes() {
      let allNodes = [];
      if (this.document.nodes.length) {
        for (let i = 0; i < this.document.nodes.length; i++) {
          // Add each section content node as its own node
          if (this.document.nodes[i].type === 'section') {
            allNodes.push(this.document.nodes[i]);

            for (let x = 0; x < this.document.nodes[i].content.length; x++) {
              allNodes.push(this.document.nodes[i].content[x]);
            }
          }
        }
      }
      this.allNodes = allNodes;
    },
    addNode(nodeType) {
      this.$emit(
        'addNode',
        new PigeonDocNodeModel({ type: nodeType, content: 'Add text here...' }),
      );
      this.showAddNode = false;
    },
    addToSelectedSlide() {
      let checkedNodes = this.deepCloneObj(this.checkedNodes);
      let new_node = {
        type: 'slide',
        id: this.document.id,
      };
      if (!this.selectedSlide) {
        this.selectedSlide = true;

        this.checkedNodes.push(new_node);
      } else {
        this.selectedSlide = false;
        this.checkedNodes = checkedNodes.filter((node) => node.id != this.document.id);
      }

      let showNodesCheckOptions = this.deepCloneObj(this.showNodesCheckOptions);
      let opennedOption = [];
      opennedOption = showNodesCheckOptions.filter((item) => item.id == this.document.id);
      if (opennedOption.length) {
        this.showNodesCheckOptions = showNodesCheckOptions.filter(
          (item) => item.id != this.document.id,
        );
      } else {
        this.showNodesCheckOptions.push(new_node);
      }
    },
    // TODO this entire page / project got messed up by index vs. node_index (as both were called index), will need a proper review and test

    addToSelectedSections(checked_node, parent_node) {
      if (this.isPlacementMode) {
        this.selectedSections = [];
        this.selectedSubSections = [];
      }
      let checkedNodes = this.deepCloneObj(this.checkedNodes);
      let checkedNodesFilter = [];
      checkedNodesFilter = checkedNodes.filter((node) => node.uuid == checked_node.uuid);
      if (checkedNodesFilter.length) {
        this.checkedNodes = checkedNodes.filter((node) => node.uuid != checked_node.uuid);
      } else {
        if (parent_node) {
          checked_node.parent_uuid = parent_node.uuid;
        }
        if (this.isPlacementMode) {
          this.checkedNodes = [];
        }
        this.checkedNodes.push(checked_node);
      }
      let showNodesCheckOptions = this.deepCloneObj(this.showNodesCheckOptions);
      let opennedOption = [];
      opennedOption = showNodesCheckOptions.filter((item) => item.uuid == checked_node.uuid);
      if (opennedOption.length) {
        this.showNodesCheckOptions = showNodesCheckOptions.filter(
          (item) => item.uuid != checked_node.uuid,
        );
      } else {
        if (this.isPlacementMode) {
          this.showNodesCheckOptions = [];
        }
        this.showNodesCheckOptions.push(checked_node);
      }
      if (this.isPlacementMode) {
        this.onClickPlace('below');
      }
    },
    onClickPlace(where) {
      this.placeWhere = where;
      let checked_node = this.deepCloneObj(this.checkedNodes[0]);
      if (checked_node) {
        // Emit to the parent
        let placement = {
          uuid: checked_node.uuid,
          where: this.placeWhere,
        };
        this.$emit('updatePlaceWhere', placement);
      }
    },
    onClickDelete() {
      let nodesToDelete = this.deepCloneObj(this.checkedNodes);
      const has_slide = nodesToDelete.filter((node) => node.type == 'slide');
      const has_section = nodesToDelete.filter((node) => node.type == 'section');
      let delete_text = 'Delete snippets?';
      if (has_slide.length || has_section.length) {
        delete_text = 'Warning: deleting slides or sections also deletes their entire contents';
      }
      this.setConfirmText({
        btn: 'Delete?',
        title: delete_text,
      });
      this.setConfirmType('delete');
      this.setConfirmSourceComponent('ToC'); // double check
      this.setConfirmStatus(false);
      this.setConfirmIsVisible(nodesToDelete.length > -1);
    },
    deleteNodes() {
      this.$emit('deleteNodes', this.checkedNodes);
    },
    highlightNodeClass(node) {
      if (!node) return '';
      if (!this.hidePlaceHandler && node.canHaveNewElement) {
        return 'toc_higlight_node';
      }
      return '';
    },
    isLastNodeInGroup(node) {
      if (!node) return '';
      if (node.canHaveNewElement) {
        return 'last_node';
      }
      return '';
    },
    parseHeader(_string) {
      if (_string.includes('<img src=')) {
        _string = _string.substring(_string.indexOf('>') + 1, _string.length);
      }

      if (_string.length >= 51) {
        _string = _string.substring(0, 50) + '...';
      }
      return _string;
    },
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
  },
  async created() {
    await this.parseNodes();
  },
  computed: {
    theseNodes() {
      return this.document.nodes;
    },
    hasTitle() {
      if (this.document.nodes.length) {
        let hasTitle = false;
        for (let x = 0; x < this.document.nodes.length; x++) {
          if (this.document.nodes[x].type === 'titlePage') {
            hasTitle = true;
            break;
          }
        }
        if (hasTitle) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    confirmStatus: async function (val) {
      if (val && this.confirmSourceComponent === 'ToC' && this.confirmType === 'delete') {
        this.deleteNodes();
      }
    },
  },
};
</script>

<style>
/* .toc {
  width: 85%;
  color: var(--primary);
  font-size: 14px;
  margin-right: 1.5rem;
} */

.toc__body {
  font-size: 0.8rem;
  position: relative;
  width: 100%;
  background-color: #f7f7f7;
  border-radius: 1em;
  box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 6px;
}

.toc__heading {
  margin: 0.5em;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.toc__nod__content--header-icon {
  height: 1em;
  width: 1em;
  margin: 0 0.5em;
}

.toc__heading--content {
  width: 80%;
  font-weight: 800;
}

.toc__heading--button {
  width: 20%;
  justify-content: center;
  display: flex;
  font-size: 0.8em;
  border: none;
  color: var(--primary);
}

.toc__node-or-section {
  height: 2em;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid var(--outline-colour);
  display: flex;
  justify-content: left;
  align-items: center;
}

.toc__is-section {
  background-color: white;
}

.toc__is-option {
  margin-top: -1em;
  background-color: white;
}

.toc__node__content--header {
  display: flex;
  font-weight: 800;
  font-size: 0.6rem;
}

.toc__section {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.toc__section-text {
  display: flex;
  overflow: hidden;
  width: 10rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: auto 0;
}

.toc__section__old {
  width: 80%;
}

.toc__section__label {
  text-align: left;
  font-size: 0.8em;
}

.toc__section__border {
  border: 1px solid #666;
  width: 100%;
  background-color: white;
}

.toc__add-node {
  text-align: right;
}

.toc__add-node-btn {
  font-size: 0.6rem;
}

.add_node-nodetypes {
  list-style-type: none;
  position: absolute;
  top: 0;
  right: 0;
  background: white;
  padding: 1rem;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.add_node-nodetypes li {
  margin: 0.5rem 0;
}

.toc__contents {
  list-style-type: none;
  padding: 0.5em;
}

.toc__contents-item {
  display: flex;
}

.toc__contents-item--warning {
  text-align: left;
  font-size: 0.8em;
  margin-right: 1em;
}

.toc_item-title {
  margin-right: auto;
  font-size: 0.8em;
  text-align: left;
  margin-left: 0.5em;
}

.toc_item-title-type {
  font-weight: 800;
}

.toc_item-title-preview {
  margin-left: 1em;
  color: black;
  font-size: 0.6em;
  font-weight: 500;
}

.toc_delete-btn {
  font-size: 0.6rem;
  margin-left: 1ch;
  align-self: center;
}

.toc_higlight_node {
  height: 2em;
  border-bottom: 4px dotted blue;
}

.last_node {
  margin-bottom: 1em;
}
</style>
